import Category from './Category';
import { defaultLang } from './enhanceCategory';
import type { Lang } from './enhanceCategory';

export default Category;
export { defaultLang };
export type { Lang };
